// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '0 !important',
    alignItems: 'center',
  },
  forgotPassword: {
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    marginTop: -5,
    marginBottom: 20,
    [theme.breakpoints.down(900)]: {
      marginBottom: 10,
    },
  },
  buttonStyle: {
    width: 200,
    background: 'none',
    margin: '5px auto 10px auto',
    [theme.breakpoints.down(900)]: {
      margin: '5px auto',
    },
  },
  submitButton: {
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    }
  },
  labelStyle: {
    color: GlobalStyles.color.COLOR_PRIMARY,
  },
  registerButton: {
    backgroundColor: 'transparent',
    border: `1px solid ${GlobalStyles.color.COLOR_PRIMARY}`,
  },
  commonError: {
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_REJECT,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  message: {
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_REJECT,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    maxWidth: 350,
    [theme.breakpoints.down(900)]: {
      marginTop: -7,
      marginBottom: -3,
    },
    [theme.breakpoints.down(570)]: {
      marginTop: 0,
      marginBottom: 0,
    },
    [theme.breakpoints.down(350)]: {
      maxWidth: 300,
    },
  },
});

export default styles;
